module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.newUser.firstName) + " " + _vm._s(_vm.newUser.lastName))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: _vm.detailsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    class: _vm.detailsActive,
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('br'), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN]),
      expression: "[USER_ROLES.ADMIN]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "btn btn-danger mr-5 mt-5",
    on: {
      "click": _vm.deleteUserModal
    }
  }, [_vm._v("Delete User\n            ")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("First Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.firstName),
      expression: "newUser.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "maxlength": _vm.max,
      "type": "text",
      "name": "firstName"
    },
    domProps: {
      "value": (_vm.newUser.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "maxlength"
    },
    slot: "maxlength"
  }, [_vm._v("First name should be less than 20 characters")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.lastName),
      expression: "newUser.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "name": "lastName"
    },
    domProps: {
      "value": (_vm.newUser.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "debounce": 250,
      "custom": {
        email: _vm.emailValidator,
        notUnique: _vm.emailUniqueValidator
      }
    }
  }, [_c('label', [_vm._v("Email :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.role),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Role:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role),
      expression: "newUser.role"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "role"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "selected": role._id === _vm.newUser.role._id,
        "value": role
      }
    }, [_vm._v(_vm._s(role.name) + "\n                    ")])
  })), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "role",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Active Status:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "placeholder": _vm.newUser.isActive == true ? 'Activated' : 'Deactivated'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6"
  }, [_c('label', [_vm._v("Enabled Status:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "placeholder": _vm.newUser.isEnabled == true ? 'Enabled' : 'Disabled'
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    attrs: {
      "id": "invisibleDiv"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(this.user1.roleName == 'Super Admin') ? _c('validate', {
    staticClass: "form-group",
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Invisible")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.invisible),
      expression: "newUser.invisible"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "invisible"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "invisible", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": false
    }
  }, [_vm._v("False")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("True")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userGroupsUpdated),
      expression: "userGroupsUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "userGroupsUpdated"
    },
    domProps: {
      "value": (_vm.userGroupsUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userGroupsUpdated = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('validate', {
    staticClass: "hide"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userPermissionsUpdated),
      expression: "userPermissionsUpdated"
    }],
    attrs: {
      "type": "text",
      "name": "userPermissionsUpdated"
    },
    domProps: {
      "value": (_vm.userPermissionsUpdated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userPermissionsUpdated = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-5 text-right row",
    staticStyle: {
      "margin-top": "10px",
      "margin-right": "auto"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "permission",
      rawName: "v-permission.enable",
      value: (['user', 'updateUser']),
      expression: "['user', 'updateUser']",
      modifiers: {
        "enable": true
      }
    }],
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty)
    },
    on: {
      "click": _vm.updateUser
    }
  }, [_vm._v("Update User\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "password"
    }
  }, [(!_vm.loading) ? _c('user-password', {
    attrs: {
      "user": _vm.newUser
    }
  }) : _vm._e()], 1)])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f1be3bfe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1be3bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/users/UserDetails.vue
// module id = 2393
// module chunks = 0